export default ({ request }) => ({
  rptCostCustListApi(data = {}) {
    return request({
      url: '/financial/rpt/cost/cust/list',
      method: 'POST',
      data,
    })
  },
})
